/** @jsx jsx */
import { jsx } from '@emotion/core';

import ContentBlocText from 'components/pages/Content/ContentBlocText';
import { ContentBlocType } from 'interfaces';
import { CONTENT_BLOC } from 'constants/content';
import {
  EventStatus,
  getPublicationStatusFromDate,
} from 'core/utils/date.helpers_ts';
import ContentBlocWidget from './ContentBlocWidget';

interface TProps {
  contentBlocks: ContentBlocType[];
}

export const ContentBlocks = ({ contentBlocks }: TProps): JSX.Element => {
  return (
    <div>
      {contentBlocks.map((contentBlock: ContentBlocType) => {
        const key = `${contentBlock['@type']}${contentBlock['@id']}`;
        switch (contentBlock['@type']) {
          case CONTENT_BLOC.TEXT:
            return <ContentBlocText key={key} {...contentBlock} />;
          case CONTENT_BLOC.WIDGET:
            const widgetStatus = getPublicationStatusFromDate(
              contentBlock.widget.diffusionStartAt,
              contentBlock.widget.diffusionEndAt,
            );
            if (!contentBlock.widget || widgetStatus !== EventStatus.RUNNING) {
              return null;
            }
            return <ContentBlocWidget key={key} {...contentBlock} />;
          default:
            return null;
        }
      })}
    </div>
  );
};
